import React from "react";
import { postEvent, editEvent, deleteEvent } from "../store/events";

import { connect } from "react-redux";
import Form from "./common/form";

import moment from "moment";

import BaseJoi from "joi-browser";
import ImageExtention from "joi-image-extension";
import { getCountries, getProvinces } from "../store/services/regions";
import { getTypes } from "../store/types";

import {isLoggedIn } from "../store/auth";

import _ from "underscore"; 

import {TIME_FORMAT} from "./common/formTimePicker";

const Joi = BaseJoi.extend(ImageExtention);

const SYSTEM_EVENT = "System event"
const PICTURES = "Pictures";
const CURRENT_IMAGES = "Current images";
const TITLE = "Title";
const OWNER = "Host";
const DATE = "Date";
const OMIT_TIME = "Omit time"
const TIME = "Time";
const COUNTRY = "Countries";
const PROVINCE = "Province";
const TOWN = "City";
const STREET_ADDRESS = "Street address";
const CONTACTS = "Contacts";
const TYPES = "Types";
const DETAILS = "Details";


const WRITE_AND_PRESS_THE_PLUS_BUTTON = "Write and press the + button";
const CHOOSE_IMAGES = "Add images";
const FILE_REQUIREMENTS = "Max file size: 10MB, accepted: jpg, jpeg, and png";

const SAVE = "Save";

class EventForm extends Form {
  initData() {
      return ({
        adminGen: false,
        pictures: [],
        title: "",
        owner: "",
        date: new Date(),
        omitTime: false,
        time: new Date(),
        country: "United States",
        province: "Indianapolis",
        town: "",
        streetAddress: "",
        contacts: [],
        types: [],
        details: "",
      });  
  }

  state = {
    data: this.initData(),
    errors: {},
    deletedImages: [],
    photoURIs: [],
    uid: "",
    edit: true,
    active: true
  };

  schema = {
    adminGen: Joi.boolean().label(SYSTEM_EVENT),
    pictures: Joi.array().label(PICTURES),
    title: Joi.string().required().label(TITLE),
    owner: Joi.string().allow(null, "").label(OWNER),
    date: Joi.date()
      // .min(new Date().setDate(new Date().getDate() + 1))
      .required()
      .label(DATE),
    omitTime: Joi.boolean().required().label(OMIT_TIME),
    time: Joi.date().required().label(TIME),
    country: Joi.string().required().label(COUNTRY),
    province: Joi.string().required().label(PROVINCE),
    town: Joi.string().required().label(TOWN),
    streetAddress: Joi.string().allow(null, "").label(STREET_ADDRESS),
    contacts: Joi.array()
      .items(Joi.string())
      .unique()
      .label(CONTACTS),
    types: Joi.array().items(Joi.string()).required().unique().label(TYPES),
    details: Joi.string().allow(null, "").label(DETAILS),
  };

  async componentDidMount() {
    window.scrollTo(0, 0);
    try {
      const isActive = this.props.currentUser? this.props.currentUser.active: false; 
      if (!isLoggedIn() || !isActive) return (window.location = "/");
      
      await this.props.getTypes();

      const id = this.props.match.params.id;  

      if(id !== "new"){ 
        let event = this.props.events.find(event => (event._id === id));
        
        const {address, dateTime, active, photoURIs, uid} = event;
        
        const ownEvent = this.props.currentUser? uid === this.props.currentUser._id && !event.adminGen: false;
        const adminPermission = this.props.currentUser? event.adminGen && this.props.currentUser.isAdmin: false;

        if (!(ownEvent || adminPermission)) return (window.location = "/");
        
        const data = {
          ..._.pick(event, [
            "omitTime",
            "contacts",
            "details",
            "owner",
            "title",
            "types"
          ]),
          country:address.country, 
          province:address.province, 
          town:address.town, 
          streetAddress:address.streetAddress,  
          date: new Date(dateTime),
          time: new Date(dateTime),
          pictures: []};
        
        this.setState({data, uid, photoURIs, active});
      }

    } catch (err) {
      console.log(err.message);
      return (window.location = "/");
    }
  }

  doSubmit = async () => {
    try {
      const { data, deletedImages } = this.state;
      const id = this.props.match.params.id;
      
      this.setState({edit: false})

      if (id === "new") await this.props.postEvent(data);
      else await this.props.editEvent(data, id, deletedImages);
          
      this.props.history.replace({
        pathname: "/",
      });

    } catch (e) {
      console.log(e);
      if (e.response && e.response.status === 400) {
        const errors = { ...this.state.errors };
        errors.title = e.response.data;
        this.setState({ errors, edit: true });
      }
    }
  };

  deleteHandler = async (e) => {
    e.preventDefault();
      try{
        await this.props.deleteEvent(this.props.match.params.id, this.state.active);
        return (window.location = "/");
        
      }catch{
        console.log(e);
        if (e.response && e.response.status === 400) {
          const errors = { ...this.state.errors };
          errors.title = e.response.data;
          this.setState({ errors });
        }
      }
  }

  render() {
    
    const edit = this.state.edit;
    const isAdmin = this.props.currentUser? this.props.currentUser.isAdmin: false; 

    return (
      <div className="d-flex justify-content-center">
        <div className="w-100 mb-4 p-4 rounded shadow" style={{maxWidth:550}}>
          <form onSubmit={this.handleSubmit}>
            {this.renderImageUploader(
              CHOOSE_IMAGES,
              FILE_REQUIREMENTS,
              10485760,
              false
            )}

            {this.props.match.params.id!=="new" && this.state.photoURIs
              ?this.renderImageArea("imageArea", CURRENT_IMAGES, this.state.photoURIs, false)
              :null}
            
            {this.renderInput("title", TITLE, false)}
            {this.renderInput("owner", OWNER, false)}
            {this.renderDatePicker(
              "date",
              DATE,
              new Date(),
              false,
              // function (current) {
              //   return current < moment().endOf("day");
              // }
            )}

            {this.renderSwitch("omitTime", OMIT_TIME, () => {
              const {data} = this.state;
              data.time =  new Date(0, 0, 0, 0, 0, 0, 0);
              this.setState({data});
            })}

            {this.renderTimePicker(
              "time",
              TIME,
              new Date(0, 0, 0, 0, 0, 0, 0),
              this.state.data.omitTime
            )}

            {this.renderSelect("country", COUNTRY, getCountries(), false)}
            {this.renderSelect("province", PROVINCE, getProvinces(this.state.data.country), false)}
            {this.renderInput("town", TOWN, false)}
            {this.renderInput("streetAddress", STREET_ADDRESS, false)}

            {this.renderTagsInput(
              "contacts",
              CONTACTS,
              false,
              WRITE_AND_PRESS_THE_PLUS_BUTTON
            )}

            {this.renderTagsInput("types", TYPES, false, "", this.props.types)}
            {this.renderTextArea("details", DETAILS, false)}
            
            {this.props.match.params.id==="new" && isAdmin
              ?this.renderSwitch("adminGen", SYSTEM_EVENT+"?")
              :null}
            
            {this.state.active
              ?this.renderButton(SAVE, !edit, "btn-dark")
              :<button
                // disabled={disabled}
                className={"btn btn-danger"}
                style={{ marginBottom: 20 }}
                onClick={this.deleteHandler}
              >
                Restore
              </button>
            }
            {this.props.match.params.id!=="new" && this.state.active===true
            ?<button
              // disabled={disabled}
              className={"btn btn-danger float-right"}
              style={{ marginBottom: 20 }}
              onClick={this.deleteHandler}
            >
              Delete
            </button>
            :null}

        
          </form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  currentUser: state.auth.currentUser,
  // token: state.auth.token,
  types: state.entities.types.list,
  events: state.entities.events.list,
});

const mapDispatchToProps = (dispatch) => ({
  deleteEvent: (id, active) => dispatch(deleteEvent(id, active)),
  postEvent: (event) => dispatch(postEvent(event)),
  editEvent: (event, id, deletedImages) => dispatch(editEvent(event, id, deletedImages)),
  getTypes: () => dispatch(getTypes()),
});

export default connect(mapStateToProps, mapDispatchToProps)(EventForm);
